/**
 * @param id
 * @param {string} url - url for the page
 * @param {*} component - relative path to the component to render a view
 * @param {boolean} isPrivate - is the route private and requires authentication
 * @param {boolean} isNavItem  - is route meant to be in the navigation
 * @param {*} name  - display name of the route in the menu
 * @param {*} icon - icon to use for the navigation menu
 * @param showMenu - indicates menu has to be shown under a specific route
 * @param children
 * @param exact - indicates if the active class of the nav item must be only applied whe the location matches exactly
 */
export const createRoute = ({
	id,
	url,
	component,
	isPrivate = true,
	isNavItem = false,
	name = "",
	icon = "",
	showMenu = true,
	children = [],
	exact = true,
	appSection
}) => {
	return {
		id,
		name,
		url,
		component,
		icon,
		isPrivate,
		isNavItem,
		showMenu,
		children,
		exact,
		appSection
	};
};

const CommonRoutes = {
	LOGIN: createRoute({
		id: "login",
		url: "/login",
		component: "login/containers/LoginContainer",
		isPrivate: false,
		name: "Home",
		icon: "home",
		showMenu: false
	}),
	BAD_REQUEST: createRoute({
		id: "400",
		url: "/400",
		component: "errors/containers/ApiErrorContainer",
		isPrivate: false,
		showMenu: false
	}),
	NOT_AUTHORIZED: createRoute({
		id: "403",
		url: "/403",
		component: "errors/containers/UnauthorizedContainer",
		isPrivate: false,
		showMenu: false
	}),
	NOT_FOUND: createRoute({
		id: "404",
		url: "/404",
		component: "errors/containers/NotFoundContainer",
		isPrivate: false,
		showMenu: false
	}),
	SERVER_ERROR: createRoute({
		id: "500",
		url: "/500",
		component: "errors/containers/ApiErrorContainer",
		isPrivate: false,
		showMenu: false
	}),
	NETWORK_ERROR: createRoute({
		id: "networkError",
		url: "/network-error",
		component: "errors/containers/ApiErrorContainer",
		isPrivate: false,
		showMenu: false
	}),
	UNHANDLED_ERROR: createRoute({
		id: "unhandledError",
		url: "/unhandled-error",
		component: "errors/containers/ApiErrorContainer",
		isPrivate: false,
		showMenu: false
	})
};

export { CommonRoutes };
